module.exports = __webpack_public_path__ + "img/cross.26f0a45f.svg";